import { createEnumParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { ProductReadModelSort, SortOrder } from '@client/api';

export const useProductListSearchQueryParams = () => {
  const result = useQueryParams({
    productsSearch: StringParam,
  });

  return result;
};

export const useProductListSortQueryParams = () => {
  const result = useQueryParams({
    productsSortProperty: withDefault<ProductReadModelSort | undefined | null, ProductReadModelSort>(
      createEnumParam(['Name']),
      'Name'
    ),
    productsSortOrder: withDefault<SortOrder | undefined | null, SortOrder>(createEnumParam(['Asc', 'Desc']), 'Asc'),
  });

  return result;
};
